import {GoogleplaceDirective} from './../../plugins/googleaddressautocomplete/google-address-autocomplete';
import {Entity, IKeyValueInterface, Marker, Permission, PermissionType, RoleLevel} from './../../shared/config';
import {AuthService} from './../../shared/models/auth.service';
import {TranslateService} from './../../shared/translate/translate.service';
import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {CompanyModel} from '../models/company.model';
import {CompanyService} from '../models/company.service';
import {PersonModel} from '../../person/models/person.model';
import {PersonService} from '../../person/models/person.service';
import {InstanceService} from '../../instance/models/instance.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ApplicationRouteURL, IAPIResponse, WeGoConfig} from '../../shared/config';
import {Location} from '@angular/common';
import {PrePostTripQuestionComponent} from '../../pre-post-trip-question/components/pre-post-trip-question.component';
import {BasePermissionModel} from '../../shared/models/base-permission-model';

import {PaymentProvider} from '../models/payment-provider';
import {Country} from '../models/country';
import forEach = require("core-js/fn/array/for-each");
import {ValidateLicense24IdCheckOption} from "../../instance/models/validate-license-24idcheck-option";

@Component({
    selector: 'wego-company',
    template: require('../views/company-update.component.html'),
    providers: [
        CompanyService,
        PersonService,
        InstanceService,
        GoogleplaceDirective
    ]
})
export class CompanyUpdateComponent
    implements OnInit, OnDestroy, AfterViewInit {
    basePermissionModel: BasePermissionModel;
    public totalItems: number = 0;
    public currentPage: number = 1;
    public maxSize: number = WeGoConfig.GRID_MAX_PAGE_SIZE;
    public itemsPerPage: number = WeGoConfig.GRID_MAX_DATA_SIZE;
    public showIdCheckConfig: boolean = false;
    model: CompanyModel;
    apiResponse: IAPIResponse;
    personList: PersonModel[];
    errorModel: IKeyValueInterface[];
    errorMessage: string;
    message: string;
    instanceList: any;
    isEditMode: boolean;
    vatEndDate: string;
    vatEndDateValidationMessage: string;
    vatIndex: any;
    public isAuthorizedForPrePostTrip: boolean;
    public searchField: string = '';
    public searchTerm: string = '';
    public selectedInstance: string = '';
    urlDefaultPage: string;
    urlCompanyList: string;
    markerInfo: Marker;
    roleLevel = RoleLevel;
    public parentCompany: string = '';
    TwoFaEnabled: boolean;
    @ViewChild('successPopup') public successPopup: any;
    @ViewChild('TwoFasuccessPopup') public TwoFasuccessPopup: any;
    @ViewChild('googleMapComp') public googleMapComp: any;
    @ViewChild('prePostTripQuestionSection')
    public prePostTripQuestionSection: PrePostTripQuestionComponent;
    @Output('OnParentCompanyChange') onParentCompanyChange = new EventEmitter();
    popupTitle: string;
    PaymentProvider = PaymentProvider;
    Country = Country;
    private companyMasterHashId: string;
    private sub: any;
    private popupMsg: string;
    private module: string;
    private breadCrumbTitle: string;
    private breadCrumbList: string;

    constructor(
        private companyService: CompanyService,
        private personService: PersonService,
        private instanceService: InstanceService,
        private translate: TranslateService,
        private activeRoute: ActivatedRoute,
        private authService: AuthService,
        private router: Router,
        private locationService: Location
    ) {
    }

    get combinedCompanyAddress(): string {
        var combinedAddress: string = '';
        combinedAddress =
            (this.model.companyAddressModel.houseNo &&
            this.model.companyAddressModel.houseNo.trim()
                ? this.model.companyAddressModel.houseNo + ', '
                : '') +
            (this.model.companyAddressModel.houseExtention &&
            this.model.companyAddressModel.houseExtention.trim()
                ? this.model.companyAddressModel.houseExtention + ', '
                : '') +
            (this.model.companyAddressModel.street &&
            this.model.companyAddressModel.street.trim()
                ? this.model.companyAddressModel.street + ', '
                : '') +
            (this.model.companyAddressModel.city &&
            this.model.companyAddressModel.city.trim()
                ? this.model.companyAddressModel.city + ', '
                : '') +
            (this.model.companyAddressModel.zipCode &&
            this.model.companyAddressModel.zipCode.trim()
                ? this.model.companyAddressModel.zipCode + ', '
                : '');

        combinedAddress = combinedAddress.trim();

        if (
            combinedAddress != null &&
            combinedAddress.length > 0 &&
            combinedAddress.charAt(combinedAddress.length - 1) == ','
        ) {
            combinedAddress = combinedAddress.substring(
                0,
                combinedAddress.length - 1
            );
        }
        return combinedAddress;
    }

    ngOnInit() {
        this.module = this.translate.instant('LblCompany');
        this.urlDefaultPage = this.authService.GetURL(
            ApplicationRouteURL.URL_DEFAULT_PAGE
        );
        this.urlCompanyList = this.authService.GetURL(
            ApplicationRouteURL.URL_COMPANY_LIST
        );
        this.model = new CompanyModel();
        this.GetCompanyDetails();
        this.IsAuthorizedForPrePostTripQuestion();
    }

    ngAfterViewInit() {
        // viewChild is set after the view has been initialized
        // this.prePostTripQuestionSection.GetPrePostTripQuestionList(
        //   null,
        //   this.companyMasterHashId,
        //   null,
        //   null
        // );
    }

    public GetCompanyDetails() {
        this.sub = this.activeRoute.params.subscribe(params => {
            this.companyMasterHashId = params['id'] || '';
            if (this.companyMasterHashId != '') {
                this.isEditMode = true;
                this.GetInstanceList();
                this.companyService
                    .GetCompanyByHashId(this.companyMasterHashId)
                    .subscribe(
                        res => {
                            this.model = res.data;
                            this.SetSelectedPaymentMethods();
                            // this.GetInstanceList();
                            this.InstanceUpdate();
                        },
                        error => {
                            this.errorMessage = this.authService.HandleErrorStatusCode(error);
                        }
                    );
            } else {
                this.isEditMode = false;
                this.model = new CompanyModel();
                this.GetInstanceList();
            }
        });
        this.breadCrumbTitle = this.isEditMode
            ? this.translate.instant('LblEditPage', [this.module])
            : this.translate.instant('LblAddPage', [this.module]);
        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    }

    onSubmit(forms: any) {
        console.log(this.model);
        this.model.paymentSettingModel.paymentMethodList = this.selectedPaymentMethods;
        this.AddCompany();
    }

    public AddCompany() {
        this.companyService.AddCompany(this.model).subscribe(
            res => {
                if (res.data) {
                    this.popupTitle = this.translate.instant('LblSuccess');
                    this.popupMsg = this.isEditMode
                        ? this.translate.instant('LblRecordUpdatedSuccess', [this.module])
                        : this.translate.instant('LblRecordAddedSuccess', [this.module]);
                    this.ShowSuccessPopup();
                } else {
                    this.errorModel = res.error;
                }
            },
            error => {
                this.errorMessage = this.authService.HandleErrorStatusCode(error);
            }
        );
    }

    public GetInstanceList() {
        let permissionType = '';
        if (this.isEditMode) {
            permissionType = PermissionType.EDIT;
        } else {
            permissionType = PermissionType.INSERT;
        }

        this.instanceService
            .GetInstanceListDropdownForAddUpdatePage('company', permissionType)
            .subscribe(
                res => {
                    this.apiResponse = res;
                    this.instanceList = res.data;
                    //this.model.instanceId = this.instanceList[0].instanceId;

                    if (this.instanceList && this.instanceList.length > 0) {
                        if (
                            !this.isEditMode &&
                            !this.model.instanceHashId &&
                            this.instanceList.length == 1
                        ) {
                            this.model.instanceHashId = this.instanceList[0].keyHash;
                        }
                    }
                },
                error => {
                    this.errorMessage = this.authService.HandleErrorStatusCode(error);
                }
            );
    }

    public InstanceUpdate() {
        this.IsAuthorizedForPrePostTripQuestion();
        if (this.model.instanceHashId) {
            this.instanceService
                .IsOdometerEnabled(this.model.instanceHashId)
                .subscribe(
                    res => {
                        this.apiResponse = res;
                        let odometerenabled: boolean = res.data;
                        if (odometerenabled) {
                            this.model.isInstanceOdometerConfiguration = true;
                            // this.model.odometerConfigurationModel = new OdometerConfigurationModel();
                        } else {
                            this.model.isInstanceOdometerConfiguration = false;
                        }
                    },
                    error => {
                        this.errorMessage = this.authService.HandleErrorStatusCode(error);
                    }
                );

            this.instanceService
                .IsDirectDebitEnabledForCompany(this.model.instanceHashId)
                .subscribe(
                    res => {
                        this.apiResponse = res;
                        let directDebitEnabled: boolean = res.data;
                        if (directDebitEnabled) {
                            this.model.directDebitFileEnabledOnInstance = true;
                        } else {
                            this.model.directDebitFileEnabledOnInstance = false;
                        }
                    },
                    error => {
                        this.errorMessage = this.authService.HandleErrorStatusCode(error);
                    }
                );

            this.instanceService
                .PaymentSettingRequiredOnInstance(this.model.instanceHashId)
                .subscribe(
                    res => {
                        this.apiResponse = res;
                        let paymentSettingEnabled: boolean = res.data;
                        if (paymentSettingEnabled) {
                            this.model.paymentSettingRequiredOnInstance = true;
                        } else {
                            this.model.paymentSettingRequiredOnInstance = false;
                        }
                    },
                    error => {
                        this.errorMessage = this.authService.HandleErrorStatusCode(error);
                    }
                );

            this.instanceService
                .IsTwoFaEnabled(this.model.instanceHashId)
                .subscribe(
                    res => {
                        this.TwoFaEnabled = res.data;
                    },
                    error => {
                        this.errorMessage = this.authService.HandleErrorStatusCode(error);
                    }
                );

        }
    }

    public ShowSuccessPopup(): void {
        this.successPopup.show();
    }

    public HideSuccessPopup(): void {
        this.successPopup.hide();
        this.OnBackClick();
    }

    public ConfirmSuccessPopup(): void {
        this.successPopup.hide();
        this.OnBackClick();
    }

    public ShowTwoFaPopup(): void {
        this.TwoFasuccessPopup.show();
    }

    // public GetGeoLocation(event: any) {
    //   if (this.model) {
    //     let locationData = event.GeoLocationData;
    //     this.model.displaycompanyGeoLocationAddress = locationData.label;
    //     this.model.companyGeoLocationLatitude = locationData.lat;
    //     this.model.companyGeoLocationLongitude = locationData.lng;
    //   }
    // }

    public ConfirmTwoFaPopup(): void {
        this.TwoFasuccessPopup.hide();
    }

    //  public GetAddress(place: Object) {

    //         this.model.displaycompanyGeoLocationAddress = place['address'];

    //         this.model.companyGeoLocationLatitude = place['lat'];

    //         this.model.companyGeoLocationLongitude = place['log'];

    //         this.model.companyGeoLocationAddress = place['useraddressInput'];
    //     }

    public OnBackClick() {
        this.locationService.back();
    }

    changeOfOdometerTimeInterval() {
        if (this.model.odometerConfigurationModel.timeInterval == 'PERBOOKING')
            this.model.odometerConfigurationModel.frequency = '';
    }

    public InitialPaymentChange() {
        if (!this.model.paymentSettingModel.initialPayment) {
            this.model.paymentSettingModel.createBookingPayment = false;
            this.model.paymentSettingModel.startBookingPayment = false;
        }
    }

    public ResetCookies() {
        this.companyService.ResetTwoFaCookies(this.companyMasterHashId)
            .subscribe(
                (res: any) => {
                    if (res.data) {
                        this.popupTitle = this.translate.instant('LblSuccess');
                        this.popupMsg = this.translate.instant('LblCookieResetSuccess', [this.module]);
                        this.ShowTwoFaPopup();
                    } else {
                        this.popupTitle = this.translate.instant('LblError');
                        this.popupMsg = this.translate.instant('LblCookieResetFailed');
                        this.ShowTwoFaPopup();
                    }
                },
                (error: any) => {
                    this.errorMessage = this.authService.HandleErrorStatusCode(error);
                });
    }

    public ResetTwoFA() {
        this.companyService.ResetTwoFaKeys(this.companyMasterHashId)
            .subscribe(
                (res: any) => {
                    if (res.data) {
                        this.popupTitle = this.translate.instant('LblSuccess');
                        this.popupMsg = this.translate.instant('LblKeyResetSuccess', [this.module]);
                        this.ShowTwoFaPopup();
                    } else {
                        this.popupTitle = this.translate.instant('LblError');
                        this.popupMsg = this.translate.instant('LblKeyResetFailed');
                        this.ShowTwoFaPopup();
                    }
                },
                (error: any) => {
                    this.errorMessage = this.authService.HandleErrorStatusCode(error);

                });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    OnVatSetting($event: any) {
        this.model.vatSettingsList = $event.vatSettingsList;
        this.model.vatSettingDefaultCost = $event.vatSettingDefaultCost;
    }

    public OnPrePostTripQuestionSetting($event: any) {
        this.model.customTripQuestionList = $event.customTripQuestionList;
    }

    public IsAuthorizedForPrePostTripQuestion() {
        let primaryPermissionType: string;
        let entity: string = '';
        let entityHashId: string = '';
        if (this.companyMasterHashId && this.companyMasterHashId != '') {
            primaryPermissionType = PermissionType.EDIT;
            entity = Entity.COMPANY;
            entityHashId = this.companyMasterHashId;
        } else {
            primaryPermissionType = PermissionType.INSERT;
            entity = Entity.INSTANCE;
            entityHashId = this.model.instanceHashId;
        }


        this.authService
            .IsAuthorizedForPrePostQuestion(
                Permission.PR_COMPANY_OVERVIEW,
                primaryPermissionType,
                Permission.PR_PREPOST_TRIP_QUESTIONS_UPDATE,
                PermissionType.VIEW,
                entity,
                entityHashId
            )
            .subscribe(
                res => {
                    this.isAuthorizedForPrePostTrip = res.data.view;
                    this.basePermissionModel = res.data;
                    console.log(this.prePostTripQuestionSection);
                },
                error => {
                    this.authService.HandleErrorStatusCode(error);
                },
                () => {
                    setTimeout(() => {
                        if (this.isAuthorizedForPrePostTrip) {
                            this.prePostTripQuestionSection.GetPrePostTripQuestionList(
                                this.companyMasterHashId ? null : this.model.instanceHashId,
                                this.companyMasterHashId,
                                null,
                                null,
                                this.basePermissionModel,
                                !this.companyMasterHashId
                            );
                        }
                    }, 1000);
                }
            );


    }

    public NavigateToPaymentConfigurationPage(e: any) {
        e.preventDefault();
        window.open(this.model.paymentSettingModel.overviewUrl, "_blank");
    }

    public SetSelectedPaymentMethods()
    {
        const modelPaymentMethods = this.model.paymentSettingModel.paymentMethodList;
        if (modelPaymentMethods && modelPaymentMethods.length > 0) {
            modelPaymentMethods.forEach((modelPaymentMethod) => {
                this.paymentMethods.forEach((paymentMethod, paymentMethodIndex) => {
                    if (modelPaymentMethod == paymentMethod.value)
                    {
                        this.paymentMethods[paymentMethodIndex].checked = true;
                    }
                })
            })
        }
    }

    paymentMethods = [
        {name: "Ideal", value:'ideal', checked: false},
        {name: "BCMC", value:'bcmc', checked: false},
        {name: "Sepa", value:'sepa', checked: false},
        //{name: "Paypal", value:'paypal-pc', checked: false},
        //{name: "Mandate", value:'mandate', checked: false},
        //{name: "Credit card", value:'creditcard', checked: false},
        {name: "MyBank", value:'mybank', checked: false},
        //{name: "Multi", value:'multi', checked: false},
    ]

    get selectedPaymentMethods() {
        return this.paymentMethods
            .filter(paymentMethod => paymentMethod.checked)
            .map(paymentMethod => paymentMethod.value)
    }

    public OnChangePaymentMethod(paymentMethod: any, isChecked: any) {
        paymentMethod.checked = isChecked;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/company/components/company-update.component.ts